export { ThemeProvider, withStyles, withTheme } from '@material-ui/styles'

export * from '@material-ui/core/styles'
export { getLuminance, lighten } from '@material-ui/core/styles/colorManipulator'
export { dark, light } from '@material-ui/core/styles/createPalette'

// Retro-compatibility Bridge : createMuiTheme -> createTheme
import { createTheme as muiCreateTheme } from '@material-ui/core/styles'

export const createTheme = muiCreateTheme
export const createMuiTheme = muiCreateTheme // Deprecated alias
